import styled from 'styled-components';
import { Color } from '../../../constants/Color';

export const StyledWrapper = styled.div`
  padding: 8px 16px;
  border-radius: 8px;
  background-color: ${Color.HeavyMetal};
  overflow-x: hidden;
`;
